
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manual/set_rules",
      function () {
        return require("private-next-pages/manual/set_rules.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manual/set_rules"])
      });
    }
  